import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import { ActivityModule } from '../activity/activity.module'
import { RoleModule } from '../role/role.module'
import * as fromSale from '../sale/sale.reducer'
import { SaleCreateComponent } from './create/show.component'
import { SaleFormComponent } from './form/form.component'
import { SaleIndexTableComponent } from './index-table/table.component'
import { SaleIndexComponent } from './index/index.component'
import { SalePaymentModalComponent } from './payment-tab/show-modal/show.component'
import { SalePaymentTabComponent } from './payment-tab/show.component'
import { PaymentModule } from './payment/payment.module'
import { PendingSaleGuard } from './pending-sale.guard'
import { SaleActivitiesMainTabComponent } from './sale-activities-tab/sale-activities-tab.component'
import { SaleSaleItemTabComponent } from './sale-item-tab/show.component'
import { SaleItemModule } from './sale-item/sale-item.module'
import { SaleRoutingModule } from './sale-routing.module'
import { SaleEffects } from './sale.effects'
import { SaleSerializer } from './sale.serializer'
import { SaleService } from './sale.service'
import { SaleShowComponent } from './show/show.component'
import { SaleActionsMainTabComponent } from './sale-actions-tab/sale-actions-tab.component'
import { SurveyModule } from '../survey/survey.module'
import { SaleDocumentsTabComponent } from './documents-tab/show.component'
import { SaleRelationEffects } from './sale-relation.effects'
import { SaleDocumentService } from './sale-document.service'
import { DocumentModule } from '../document/document.module'
import { BookingMultiDayModule } from './booking-multi-day/booking-multi-day.module'
import { SaleTableAjaxComponent } from './sale-table-ajax/sale-table-ajax.component'
import { NzTableModule } from 'ng-zorro-antd/table'
import { SaleOrganizeTabComponent } from './organize-tab/show.component'
import { OrganizeBookingsComponent } from './organize-tab/organize-bookings/organize-bookings.component'
import { OrganizeBookingsInterfaceComponent } from './organize-tab/organize-bookings-interface/organize-bookings-interface.component'
import { OrganizeBookingsModalComponent } from './organize-tab/organize-bookings-modal/organize-bookings-modal.component'
import { ProductModule } from '../product/product.module'
import { SaleCommunicationTabComponent } from './communication-tab/communication-tab.component'
import { EmailTaskModule } from '../email-task/email-task.module'
import { EmailLogModule } from '../email-log/email-log.module'
import { OperationTabComponent } from './operation-tab/operation-tab.component'
import { DmsTableModule } from 'src/app/shared/components/dms-table/dms-table.module'
import { ReportEffects } from '../report/report.effects'
import { ReportSerializer } from '../report/report.serializer'
import { SaleGeneralCardComponent } from './general-card/show.component'
import { SaleGeneralMainTabComponent } from './sale-general-tab/sale-general-tab.component'
import { CommunicationBlockModule } from 'src/app/shared/components/communication-block/communication-block.module'
import { activitiesBlockModule } from 'src/app/shared/components/activities-block/activities-block.module'
import { SaleEmailLogsTabComponent } from './email-logs/show.component'
import { SaleCourseCancelModalComponent } from './sale-course-cancel-modal/sale-course-cancel-modal.component'

@NgModule({
  imports: [
    CommonModule,
    SaleRoutingModule,
    SharedModule,
    StoreModule.forFeature(fromSale.FEATURE_NAME, fromSale.saleReducer),
    EffectsModule.forFeature([SaleEffects, SaleRelationEffects, ReportEffects]), // ReportEffects needed to dispatch actions
    ProductModule,
    ActivityModule,
    PaymentModule,
    SaleItemModule,
    RoleModule,
    SurveyModule,
    DocumentModule,
    BookingMultiDayModule,
    NzTableModule,
    EmailTaskModule,
    SurveyModule,
    EmailLogModule,
    DmsTableModule,
    CommunicationBlockModule,
    activitiesBlockModule
  ],
  declarations: [
    SaleFormComponent,
    OperationTabComponent,
    SaleCreateComponent,
    SaleShowComponent,
    SaleIndexComponent,
    SaleGeneralMainTabComponent,
    SaleActivitiesMainTabComponent,
    SaleGeneralCardComponent,
    SaleOrganizeTabComponent,
    SaleSaleItemTabComponent,
    SalePaymentTabComponent,
    SalePaymentModalComponent,
    SaleIndexTableComponent,
    SaleActionsMainTabComponent,
    SaleDocumentsTabComponent,
    SaleTableAjaxComponent,
    OrganizeBookingsComponent,
    OrganizeBookingsInterfaceComponent,
    OrganizeBookingsModalComponent,
    SaleCommunicationTabComponent,
    SaleEmailLogsTabComponent,
    SaleCourseCancelModalComponent
  ],
  exports: [SaleItemModule, SaleTableAjaxComponent],
  providers: [
    SaleService,
    SaleDocumentService,
    {
      provide: SaleSerializer,
      useClass: SaleSerializer
    },
    {
      provide: ReportSerializer,
      useClass: ReportSerializer // ReportEffects needs ReportSerializer
    },
    PendingSaleGuard
  ]
})
export class SaleModule {}
